import { _Col2CustomAttributes } from "./collection";
import { _Page2CustomAttributes } from "./page";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as V from "@discovery/prelude/lib/data/validated";
import * as E from "@discovery/prelude/lib/data/either";
import * as M from "@discovery/prelude/lib/data/maybe";
/**
 * Lens for `CustomAttributes` given a `Validator`
 * This Lens finds the custom attributes for a component and test if they
 * conform to the provided validator.
 * example
 * ```typescript
 * const validator = record({prefix: optional(string)})
 *
 * const customAttributes = Fold.preview(_GetCustomAttributesForComponent(validator), data)
 * ```
 *
 */
export const _GetCustomAttributesForComponent = (validator) => {
    return Fold.compose(_Col2CustomAttributes, M._Just(), Fold.mapF((a) => V.validate(validator, a)), E._Right());
};
/**
 * Lens for `CustomAttributes` given a `Validator`
 * This Lens finds the custom attributes for a page and test if they
 * conform to the provided validator.
 * example
 * ```typescript
 * const validator = record({prefix: optional(string)})
 *
 * const customAttributes = Fold.preview(_GetCustomAttributesForPage(validator), data)
 * ```
 *
 */
export const _GetCustomAttributesForPage = (validator) => {
    return Fold.compose(_Page2CustomAttributes, M._Just(), Fold.mapF((a) => V.validate(validator, a)), E._Right());
};

